'use client'
import { htmlSuffix, publicPath } from './header'
import top_banner from '@/assets/images/banners/top_banner.png';
import xinchuang_banner from '@/assets/images/xinchuang/banner.png';
import xinchuanggate_banner from '@/assets/images/xinchuanggateway/banner.png';
import banner_mobile from '@/assets/images/xinchuang/banner_mobile.png';
import TitleComp from "@/components/titleBox";
import { imgList01, imgList011, titleList01 } from "@/constants/government";
import intelligentservice_banner_txt from '@/assets/images/intelligentservice/banner_txt.png';
import intelligentservice_banner from '@/assets/images/intelligentservice/banner.png';
import instructplatfrom_banner_txt from '@/assets/images/instructplatfrom/banner_txt.png';
import instructplatfrom_banner from '@/assets/images/instructplatfrom/banner.png';
import videoconference_banner from '@/assets/images/videoconference/banner.png';
import agentplatform_banner_txt from '@/assets/images/agentplatform/banner_txt.png';//
import agentplatform_banner from '@/assets/images/agentplatform/banner.png';//
import imintegration_banner from '@/assets/images/imintegration/banner.png';//
import banner_watermark from '@/assets/images/watermark/banner.png';//banner-安全保密
import banner_filecollaborate from '@/assets/images/filecollaborate/banner.png';//banner-办公协同
import banner_filecollaborate_1 from '@/assets/images/filecollaborate/banner_1.png';//banner-办公协同
import banner_mobileportal from '@/assets/images/filecollaborate/banner_1.png';//banner-移动门户
import banner_intelservice from '@/assets/images/intelService/banner.png';//banner-业务协同
import banner_lowcodeplat from '@/assets/images/lowcodeplat/banner.png';//banner-业务融合
import banner_clouddocument from '@/assets/images/clouddocument/banner.png';//banner-云文档
import banner_lowcodeplat_1 from '@/assets/images/lowcodeplat/banner_1.png';//banner-业务融合
import banner_announcement from '@/assets/images/announcement/banner.png';//banner-应用集市
import banner_leaderpattern from '@/assets/images/leaderpattern/banner.png';//banner-可管可控
import banner_advantage from '@/assets/images/advantage/banner-ys.png';//banner-优势特色
import banner_synergy from '@/assets/images/synergy/banner_synergy.png';//banner-智慧协同

import about_banner from '@/assets/images/about/banner.png';
import banner_two from '@/assets/images/about/banner_two.png';
import about_banner_mobile from '@/assets/images/about/banner_mobile.png';
import about_banner_mobile1 from '@/assets/images/about/banner-mobile.png';
import banner_two_mobile from '@/assets/images/about/banner_two_mobile.png';

import banner_langding from "@/assets/images/landing/banner.png";
import banner_langding_mobile from "@/assets/images/landing/banner_mobile.png";

import banner_img01 from '@/assets/images/instant/banner.png';
import banner_instant_mobile from '@/assets/images/instant/banner-mobile.png';
import banner_robot_img01 from '@/assets/images/intelrobot/banner_img01.png';

import case_img01 from '@/assets/images/unifiedportal/case_img01.png';
import case_img02 from '@/assets/images/unifiedportal/case_img02.png';
import case_img03 from '@/assets/images/unifiedportal/case_img03.png';
import case_img04 from '@/assets/images/unifiedportal/case_img04.png';
import case_logo01 from '@/assets/images/unifiedportal/case_logo01.png';
import case_logo02 from '@/assets/images/unifiedportal/case_logo02.png';
import case_logo03 from '@/assets/images/unifiedportal/case_logo03.png';
import case_logo04 from '@/assets/images/unifiedportal/case_logo04.png';

import indexBanner01 from '@/assets/images/home/indexBanner/banner1.jpg';
import banner1_mobile from '@/assets/images/home/indexBanner/banner1_mobile.png';
import indexBanner02 from '@/assets/images/home/indexBanner/banner2.jpg';
import banner2_mobile from '@/assets/images/home/indexBanner/banner2_mobile.png';
import indexBanner03 from '@/assets/images/home/indexBanner/banner3.jpg';
import banner3_mobile from '@/assets/images/home/indexBanner/banner3_mobile.png';
import banner3txt from '@/assets/images/home/indexBanner/banner3txt.png';
import indexBannerMP4 from '@/assets/images/home/indexBanner/banner.mp4';

import indexBanner04 from '@/assets/images/home/indexBanner/banner04.jpg';
import indexBanner04_mobile from '@/assets/images/home/indexBanner/banner4yd-3X.png';
import indexBanner05_mobile from '@/assets/images/home/indexBanner/banner5yd-3X.png';
import indexBanner05 from '@/assets/images/home/indexBanner/banner5.png';

import secret_banner from '@/assets/images/secret/banner.png';
import secret_banner_mobile from '@/assets/images/secret/banner_mobile.png';

import imintegration_banner_mobile from '@/assets/images/imintegration/banner-mobile.png';
import videoconference_banner_mobile from '@/assets/images/videoconference/banner_mobile.png';
import workportal_banner_mobile from '@/assets/images/workportal/banner_mobile.png';
import mobileportal_banner_mobile from '@/assets/images/mobileportal/banner_mobile.png';
import lowcodeplat_banner_mobile from '@/assets/images/lowcodeplat/banner-mobile.png';
import clouddocument_banner_mobile from '@/assets/images/clouddocument/banner_mobile.png';
import intelligentservice_banner_mobile from '@/assets/images/intelligentservice/banner-mobile.png';
import agentplatform_banner_mobile from '@/assets/images/agentplatform/banner-mobile.png';//
import instructplatfrom_banner_mobile from '@/assets/images/instructplatfrom/banner-mobile.png';
import { registers } from "@/constants/header";

export const path = "/site/"
export const homeBannerList = ['homeBanner01', 'homeBanner02', 'homeBanner03', 'homeBanner04']//, 'homeBanner05' 第5帧
export const list: any = {
    homeBanner01: {
        imgUrl: indexBanner01.src,
        imgMobileUrl: banner1_mobile.src,
        toClickMP4: true,
        topTxt: '「全景化」',
        title: '智能协同工作平台',
        contSpan:14,
        buttonText:'立即体验',
        tipList: ['极致连接  •  闭环协作  •  业务融合  •  安全可控'],
    },
    homeBanner02: {
        imgUrl: indexBanner02.src,
        imgMobileUrl: banner2_mobile.src,
        title: '为大型政企组织复杂业务而生',
        contSpan:14,
        buttonText:'立即体验',
        tipList: ['20个行业、数千家大型政企客户共同的选择'],
        seat:true //占位
    },
    homeBanner03: {
        title: '工作从360智语开始',
        tipList: ['20个行业、数千家大型政企客户共同的选择!'],
        buttonText: "立即体验",
        contSpan:14,
        imgUrl: indexBanner03.src,
        imgMobileUrl: banner3_mobile.src,
        mp4Url: indexBannerMP4,
        seat:true //占位
    },
    homeBanner04: {
        imgMobileUrl: indexBanner04_mobile.src,
        imgUrl: indexBanner04.src,
        topTxt:"全国首批！",
        title:"360智语获得涉密信息系统产品检测证书",
        tipList:['证书编号：国保测 2024C14865'],
        buttonText: "立即体验",
        contSpan:16,
    },
    homeBanner05: {
        imgMobileUrl: indexBanner05_mobile.src,
        imgUrl: indexBanner05.src,
    },

    landing: {
        title: ['数智赋能', '探索全新“AI+”办公'],
        tipList: ['360智语8.0版本全新发布'],
        imgUrl: banner_langding.src,
        imgMobileUrl: banner_langding_mobile.src,
        buttonText: "立即体验",
    },
    workingring: {
        title: ['工作圈', '让组织有活力、工作有激情'],
        imgUrl: banner_announcement.src,
        buttonText: "立即体验",
    },
    safeaudit: {
        title: ['安全审计', '消除APP安全隐患'],
        imgUrl: banner_watermark.src,
        buttonText: "立即体验",
    },
    publicaccount: {
        title: ['公众号', '高效传播组织文宣'],
        imgUrl: banner_announcement.src,
        buttonText: "立即体验",
    },
    auditplatform: {
        title: ['审计平台', '使企业数据可管可控'],
        imgUrl: banner_leaderpattern.src,
        buttonText: "立即体验",
    },
    applicationaudit: {
        title: ['应用审核', '确保应用接入安全'],
        imgUrl: banner_leaderpattern.src,
        buttonText: "立即体验",
    },
    equipmentcontrol: {
        title: ['设备管控', '确保客户端设备的使用安全'],
        imgUrl: banner_leaderpattern.src,
        buttonText: "立即体验",
    },
    serverapi: {
        title: ['服务端API', '应用与平台连接的桥梁'],
        imgUrl: banner_lowcodeplat.src,
        buttonText: "立即体验",
    },
    appintegration: {
        title: ['H5应用API', '让轻应用与平台集成更简单'],
        imgUrl: banner_lowcodeplat.src,
        buttonText: "立即体验",
    },
    clientsdk: {
        title: ['客户端SDK', '快速为您的APP赋能'],
        imgUrl: banner_lowcodeplat.src,
        buttonText: "立即体验",
    },
    clouddocument: {
        title: ['云文档', '多人协作知识创作与管理平台'],
        imgUrl: banner_clouddocument.src,
        imgMobileUrl: clouddocument_banner_mobile.src,
        buttonText: "立即体验",
        contSpan:16,
        fontClass:"fontBlack"
    },
    smallproframe: {
        title: ['小程序框架', '打造媲美原生体验的跨端应用'],
        imgUrl: banner_lowcodeplat.src,
        buttonText: "立即体验",
    },
    lowCodePlat: {
        title: ['低代码平台', '可视化快速搭建应用，降本增效'],
        imgUrl: banner_lowcodeplat_1.src,
        imgMobileUrl: lowcodeplat_banner_mobile.src,
        buttonText: "立即体验",
        fontClass:"fontBlack"
    },
    intelrobot: {
        bgClass: "bg01",
        title: ['机器人通道', '让人与系统高效协作'],
        imgUrl: banner_intelservice.src,
        buttonText: "立即体验",
        // rightImgStyle: {
        //     style: { marginRight: '-30px' }
        // }
    },
    intelservice: {
        title: ['智能服务台', '提供不间断的智能服务'],
        imgUrl: banner_intelservice.src,
        buttonText: "立即体验",
    },
    largebook: {
        bgClass: "bg01",
        title: '可管可控的大组织通讯录',
        tipList: ["20个行业，近千家大型企业客户共同的选择！"],
        imgUrl: banner_filecollaborate.src,
        buttonText: "立即体验",
        btnLink: ''
    },
    todocenter: {
        bgClass: "bg01",
        title: ['待办中心', '统一的流程协作入口'],
        imgUrl: banner_intelservice.src,
        buttonText: "立即体验",
        btnLink: registers
    },
    appcenter: {
        bgClass: "bg01",
        title: ['应用中心', '将应用整合一处，让您触手可得'],
        tipList: ["WEB、H5、原生应用全集成，单点登录对接，一键访问业务应用"],
        imgUrl: banner_intelservice.src,
        //rightImg: banner_img01,
        buttonText: "立即体验",
        btnLink: registers,
    },
    announcement: {
        bgClass: "bg01",
        title: ['电子公告', '高效传达，让每个人都能收到'],
        imgUrl: banner_announcement.src,
        buttonText: "立即体验",
    },
    votequestion: {
        bgClass: "bg01",
        title: ['投票问卷', '一站式调研工具'],
        imgUrl: banner_announcement.src,
        buttonText: "立即体验",
    },
    teamsch: {
        bgClass: "bg01",
        title: ['团队日程', '让工作安排井然有序'],
        imgUrl: banner_announcement.src,
        buttonText: "立即体验",
    },
    meeting: {
        bgClass: "bg01",
        title: ['会议室预订', '提升会议室使用效率'],
        imgUrl: banner_announcement.src,
        buttonText: "立即体验",
    },
    task: {
        bgClass: "bg01",
        title: ['任务', '工作进度尽在掌握'],
        imgUrl: banner_announcement.src,
        buttonText: "立即体验",
    },
    appreinforce: {
        bgClass: "bg01",
        title: ['APP加固', '全生命周期守护应用安全'],
        imgUrl: banner_watermark.src,
        buttonText: "立即体验",
    },
    highlowcontrol: {
        bgClass: "bg01",
        title: ['高密低流管控', '实现工作消息密级管控'],
        imgUrl: banner_watermark.src,
        buttonText: "立即体验",
    },
    watermark: {
        bgClass: "bg01",
        title: ['安全水印', '全方位守护平台数据安全'],
        imgUrl: banner_watermark.src,
        buttonText: "立即体验",
    },
    filehang: {
        bgClass: "bg01",
        title: ['文件不落地', '文件闭环传递，下载可控'],
        imgUrl: banner_watermark.src,
        buttonText: "立即体验",
    },
    farerasure: {
        bgClass: "bg01",
        title: ['远程数据擦除', '设备遗失，数据无忧'],
        imgUrl: banner_watermark.src,
        buttonText: "立即体验",
    },
    ranklimits: {
        bgClass: "bg01",
        title: ['分级分权', '使管理更高效'],
        imgUrl: banner_leaderpattern.src,
        buttonText: "立即体验",
    },
    leaderpattern: {
        bgClass: "bg01",
        title: ['高管模式', '避免无效消息的打扰'],
        imgUrl: banner_leaderpattern.src,
        buttonText: "立即体验",
    },
    operationspla: {
        bgClass: "bg01",
        title: ['运维系统', '为平台稳定运行保驾护航'],
        imgUrl: banner_leaderpattern.src,
        buttonText: "立即体验",
    },
    operationana: {
        bgClass: "bg01",
        title: ['运营分析', '使用数据辅助业务决策'],
        imgUrl: banner_leaderpattern.src,
        buttonText: "立即体验",
    },
    xinchuang: {
        bgClass: "bg01",
        title: '信创协同办公行业“领跑者”',
        tipList: ['基于信创体系的即时通讯与协同平台解决方案，信创和非信创环境融合，支持混合部署、同源部署'],
        imgUrl: xinchuang_banner.src,
        imgMobileUrl: banner_mobile.src,
        buttonText: "立即体验",
        btnLink: '',
        fontClass:"fontBlack"
    },
    xinchuanggateway: {
        bgClass: "bg01",
        title: '360智语信创门户平台',
        tipList: ['统一入口·灵活敏捷· 安全稳定·自主可控'],
        imgUrl: xinchuanggate_banner.src,
        buttonText: "立即体验",
        btnLink: '',
        titleTip:"titleTip"
    },
    xinchuangcommunication:{
        bgClass: "bg01",
        title: '360智语信创即时通讯协同平台',
        tipList: ['自主可控、安全稳定、全面适配、支持涉密'],
        imgUrl: xinchuanggate_banner.src,
        buttonText: "立即体验",
        btnLink: '',
        titleTip:"titleTip"
    },
    workportal: {
        bgClass: "bg01",
        title: ['统一门户', '跨端、千人千面的工作入口'],
        tipList: ['为政企大型组织复杂业务构建统一的工作入口，便捷访问工作资源、数据及应用、开展工作'],
        imgUrl: banner_filecollaborate_1.src,
        imgMobileUrl: workportal_banner_mobile.src,
        buttonText: "立即体验",
        btnLink: '',
        fontClass:"fontBlack"
    },
    mobileportal: {
        bgClass: "bg01",
        title: ['数字化移动门户', '企业、组织或个人的一站式移动端入口'],
        // tipList: ['为政企大型组织复杂业务构建统一的工作入口，便捷访问工作资源、数据及应用、开展工作'],
        imgUrl: banner_mobileportal.src,
        imgMobileUrl: mobileportal_banner_mobile.src,
        buttonText: "立即体验",
        btnLink: '',
        fontClass:"fontBlack"
    },
    messagecenter: {
        bgClass: "bg01",
        title: ['消息中心', '事找人闭环协作'],
        imgUrl: banner_filecollaborate.src,
        buttonText: "立即体验",
        btnLink: registers
    },
    instant: {
        bgClass: "bg01",
        title: ['即时通讯', '安全、可控的团队沟通'],
        // tipList: ["信创操作系统；Windows、MAC、安卓、iOS、鸿蒙、平板、浏览器全端支持"],
        imgUrl: banner_img01.src,
        imgMobileUrl: banner_instant_mobile.src,
        //rightImg: banner_img01,
        buttonText: "立即体验",
        btnLink: registers,
        rightImgStyle: {
            style: { marginRight: '-30px' }
        },
        fontClass:"fontBlack"
    },
    advantage:{
        bgClass: "bg01",
        title: ['工作从360智语开始'],
        tipList: ['让工作更简单、更高效、更安全、更智能！'],
        imgUrl: banner_advantage.src,
        //rightImg: banner_img01,
        buttonText: "立即体验",
        btnLink: registers,
        rightImgStyle: {
            style: { marginRight: '-30px' }
        },
        titleTip:"titleTip",
        fontClass:"fontBlack"
    },
    synergy:{
        bgClass: "bg01",
        // title: ['工作从360智语开始'],
        // tipList: ['让工作更简单、更高效、更安全、更智能！'],
        imgUrl: banner_synergy.src,
        // rightImg: banner_img01,
        // buttonText: "立即体验",
        // btnLink: registers,
        // rightImgStyle: {
        //     style: { marginRight: '-30px' }
        // },
        titleTip:"titleTip",
        fontClass:"fontBlack"
    },
    filecollaborate: {
        bgClass: "bg01",
        title: ['随时随地', '轻松实现文件存储共享与协作'],
        tipList: ["私有化集中存储/精细权限控制/内外网文件摆渡/文件安全防护"],
        imgUrl: banner_filecollaborate.src,
        buttonText: "立即体验",
        btnLink: registers,
        fontClass:"fontBlack"

    },
    about: {
        //bgClass: "bg01",
        title: '全景化智能协同工作平台',
        tipList: ['用消息连接工作，用消息驱动工作 让用户的工作协同变得更方便、更高效、更','安全、更智能'],
        imgUrl: about_banner.src,
        imgMobileUrl: about_banner_mobile1.src,
        buttonText: "立即体验",
        imgList: {
            '1': about_banner.src,
            '2': about_banner.src,
            '3': banner_two.src,
            '4': banner_two.src,
        },
        imgListMoblie: {
            '1': about_banner_mobile.src,
            '2': about_banner_mobile.src,
            '3': banner_two_mobile.src,
            '4': banner_two_mobile.src,
        },
        fontClass:"fontBlack"
    },
    teamspace: {
        bgClass: "bg01",
        title: ['以业务为中心', '打造"一站式"团队工作空间'],
        imgUrl: banner_leaderpattern.src,
        buttonText: "立即体验",
        fontClass:"fontBlack"
    },
    secret: {
        imgUrl: secret_banner.src,
        imgMobileUrl: secret_banner_mobile.src,
        title: '保守工作秘密 筑牢铜墙铁壁',
        contSpan:14,
        buttonText:'立即体验',
        tipList: ['360智语涉密即时通讯平台重磅上线'],
        fontClass:"fontBlack"
    },
    imintegration: {
        imgUrl: imintegration_banner.src,
        imgMobileUrl: imintegration_banner_mobile.src,
        title: ["客户端SDK,快速为您的", "APP赋能"],
        contSpan: 14,
        buttonText: "立即体验",
        fontClass:"fontBlack"
    },
    agentplatform: {
        imgUrl: agentplatform_banner.src,
        imgMobileUrl: agentplatform_banner_mobile.src,
        contSpan: 14,
        title:['360Agent开发平台','一站式大模型应用开发平台'],
        buttonText: "立即体验",
        fontClass:"fontBlack"
    },
    instructplatfrom: {
        imgUrl: instructplatfrom_banner.src,
        imgMobileUrl: instructplatfrom_banner_mobile.src,
        contSpan: 14,
        title:['360AI训推平台','让大模型更懂业务、更懂企业'],
        buttonText: "立即体验",
        fontClass:"fontBlack"
    },
    intelligentservice: {
        imgUrl: intelligentservice_banner.src,
        imgMobileUrl: intelligentservice_banner_mobile.src,
        contSpan: 14,
        title:['智能客服','提供不间断的智能服务'],
        buttonText: "立即体验",
        fontClass:"fontBlack"
    },
    videoconference: {
        imgUrl: videoconference_banner.src,
        imgMobileUrl: videoconference_banner_mobile.src,
        contSpan: 14,
        title:['视频会议'],
        tipList:['视频会议依托360智汇云自研的RTC技术,为政企提供安全、稳定、低延迟的互动会议解决方案,满足政企工作中跨地域实时沟通需求,赋能政企数智化转型'],
        buttonText: "立即体验",
        fontClass:"fontBlack"
    },
}
export const allTab: any = {
    about: [{
        key: `${publicPath}/about/company${htmlSuffix}`,
        name: "公司介绍",
    }, {
        key: `${publicPath}/about/honor${htmlSuffix}`,
        name: "荣誉资质"
    }, {
        key: `${publicPath}/about/service${htmlSuffix}`,
        name: "客户服务"
    }, {
        key: `${publicPath}/about/cooper${htmlSuffix}`,
        name: "生态合作 "
    }],
    teachscience: [
        // {
        //     key: '1',
        //     name: "教育",
        // },
        {
            key: `${publicPath}/teachscience/research${htmlSuffix}`,
            name: "科研机构"
        },
        {
            key: `${publicPath}/teachscience/medical${htmlSuffix}`,
            name: "医疗"
        }
    ],
    centerenterprise: [
        {
            key: `${publicPath}/centerenterprise/bank${htmlSuffix}`,
            name: '银行',
        },
        {
            key: `${publicPath}/centerenterprise/insurance${htmlSuffix}`,
            name: '保险',
        },
        // {
        //     key: '3',
        //     name: '资产管理',
        // },
        {
            key: `${publicPath}/centerenterprise/airline${htmlSuffix}`,
            name: '航司',
        },
        {
            key: `${publicPath}/centerenterprise/airport${htmlSuffix}`,
            name: '机场',
        },
        {
            key: `${publicPath}/centerenterprise/warindustry${htmlSuffix}`,
            name: '军工',
        },
        {
            key: `${publicPath}/centerenterprise/energy${htmlSuffix}`,
            name: '能源',
        },
        {
            key: `${publicPath}/centerenterprise/highmake${htmlSuffix}`,
            name: '高端制造',
        }
    ],
    government: [

        {
            key: `${publicPath}/government/city${htmlSuffix}`,
            name: '城市',
        },
        {
            key: `${publicPath}/government/affairs${htmlSuffix}`,
            name: '政务',
        },
        // {
        //     key: '3',
        //     name: '应急',
        // },
        {
            key: `${publicPath}/government/inspection${htmlSuffix}`,
            name: '纪检',
        },
        {
            key: `${publicPath}/government/taxation${htmlSuffix}`,
            name: '税务',
        },
        {
            key: `${publicPath}/government/water${htmlSuffix}`,
            name: '水务',
        },
        // {
        //     key: '7',
        //     name: '军队',
        // }
    ],
    coordinationList:[
        {
            key: "0",
            name: '城市',
            children:"0"
        },
        {
            key: "1",
            name: '政务',
            children:"1"
    
        },
    
        {
            key: "2",
            name: '纪检',
            children:"2"
    
        },
        {
            key: "3",
            name: '税务',
            children:"3"
    
        },
        {
            key: "4",
            name: '水务',
            children:"4"
    
        },
    ],
    policeplatform:[
        {
            key: `${publicPath}/policeplatform/aibase${htmlSuffix}`,
            name: '人工智能服务底座',
        },
        {
            key: `${publicPath}/policeplatform/newpolicepla${htmlSuffix}`,
            name: '协同智能警务平台',
        },
        {
            key: `${publicPath}/policeplatform/operatepla${htmlSuffix}`,
            name: '安全运营协同处置平台',
        },
        {
            key: `${publicPath}/policeplatform/collaboratepla${htmlSuffix}`,
            name: '一体化涉密信创协作平台',
        },
    ]
}

export const caseList = {
    title: '成功案例',
    list: [{
        titImg: case_img01.src,
        logImg: case_logo01.src,
        cont: '围绕用户的操作习惯和需求，连接汇聚各系统的信息、流程和待办等，构建智能化工作平台，汇聚信息、联结数据、集成应用，并打造成统一待办中心。'
    },

    {
        titImg: case_img02.src,
        logImg: case_logo02.src,
        cont: '以SDK的方式快速接入消息推送、即时通讯等能力;助力上海铁路局自研的移动门户平台;提升消息推送、一键审批、即时通讯等能力。'
    },
    {
        titImg: case_img04.src,
        logImg: case_logo04.src,
        cont: '提供PC 、移动端多端的安全沟通平台，完善组织架构/人员管理，实现分级分权、名片管理、部门群、群名片等功能，提升沟通管理，建设协作管理。'
    }
    ]
}
export const serviceList = [
    "xinchuanggateway",
    "xinchuangcommunication"
]